import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <circle
          cx={15.5}
          cy={15.5}
          r={15}
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.52 17.89a11.08 11.08 0 01.07-1.34 5.31 5.31 0 01.25-1.11 3.72 3.72 0 01.48-.93 4.46 4.46 0 01.76-.82 8.37 8.37 0 001.23-1.24 2.07 2.07 0 00.46-1.3 1.85 1.85 0 00-.37-1.28 1.37 1.37 0 00-1.08-.4 1.5 1.5 0 00-.56.1 1.29 1.29 0 00-.48.33 1.78 1.78 0 00-.34.56 2.48 2.48 0 00-.14.83H10a5 5 0 01.43-2.15 4.11 4.11 0 011.12-1.47 4.61 4.61 0 011.67-.84 8.21 8.21 0 014.25 0 4.59 4.59 0 011.65.84 3.67 3.67 0 011 1.39 4.7 4.7 0 01.36 1.9 3.73 3.73 0 01-.21 1.3 4 4 0 01-.57 1.06 6.75 6.75 0 01-.85.95l-1.05 1a3.54 3.54 0 00-.54.57 2.71 2.71 0 00-.35.58 3.47 3.47 0 00-.19.67 6.44 6.44 0 00-.07.8zm-.46 3.4a1.86 1.86 0 01.15-.75 1.84 1.84 0 01.43-.6 2.2 2.2 0 01.66-.4 2.52 2.52 0 01.85-.14 2.57 2.57 0 01.85.14 2.2 2.2 0 01.66.4 1.81 1.81 0 01.42.6 1.81 1.81 0 010 1.49 1.81 1.81 0 01-.42.6A2.2 2.2 0 0116 23a2.57 2.57 0 01-.85.14 2.52 2.52 0 01-.85-.14 2.2 2.2 0 01-.66-.4 1.78 1.78 0 01-.58-1.34z"
          fill="fj-icons-primary-color"
        />
      </g>
    </g>
  </svg>
);

const Help = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Help;
